interface BodyStyleSnapshot {
  overflow: string
  position: string
  top: string
  left: string
  width: string
}

let lockCount = 0
let scrollX = 0
let scrollY = 0
let bodyStyleSnapshot: BodyStyleSnapshot | null = null

export const acquireMobileSheetScrollLock = (): void => {
  lockCount += 1
  if (lockCount > 1) return

  scrollX = window.scrollX
  scrollY = window.scrollY
  bodyStyleSnapshot = {
    overflow: document.body.style.overflow,
    position: document.body.style.position,
    top: document.body.style.top,
    left: document.body.style.left,
    width: document.body.style.width,
  }

  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollY}px`
  document.body.style.left = `-${scrollX}px`
  document.body.style.width = '100%'
}

export const releaseMobileSheetScrollLock = (): void => {
  if (lockCount === 0) return
  lockCount -= 1
  if (lockCount > 0 || !bodyStyleSnapshot) return

  document.body.style.overflow = bodyStyleSnapshot.overflow
  document.body.style.position = bodyStyleSnapshot.position
  document.body.style.top = bodyStyleSnapshot.top
  document.body.style.left = bodyStyleSnapshot.left
  document.body.style.width = bodyStyleSnapshot.width
  bodyStyleSnapshot = null
  if (Math.abs(window.scrollX - scrollX) > 1 || Math.abs(window.scrollY - scrollY) > 1) {
    window.scrollTo(scrollX, scrollY)
  }
}
